/**
 * Pending or saved custom font package row for Portal Edge: filename(s), optional API upload label,
 * and delete control. Styling relies on parent card SCSS (font-package-file-actions-list).
 */

import { FC } from 'react';
import FontBody2 from '../../../../../components/fonts/font-body2/font-body2';
import { FONT_COLOR } from '../../../../../components/fonts/font-props';
import IconDelete from '../../../../../components/icons/icon-delete/icon-delete';
import { Tooltip } from '../../../../../components/tooltip/tooltip';
import Icon from '../../../../../components/icons/icon/icon';
import FontPackageFileActionsList from './font-package-file-actions-list';

export interface IPortalEdgeFontPackageDisplayProps {
    isLoading: boolean;
    hasPendingPackage: boolean;
    pendingPackageFileName?: string;
    customFontUploadOriginalName?: string;
    customFontFiles: { filename: string }[];
    onDeleteCustomFont: () => void;
}

const PortalEdgeFontPackageDisplay: FC<IPortalEdgeFontPackageDisplayProps> = ({
    isLoading,
    hasPendingPackage,
    pendingPackageFileName,
    customFontUploadOriginalName,
    customFontFiles,
    onDeleteCustomFont,
}) => {
    const innerFilesTooltip = customFontFiles.map((f) => f.filename).join('\n');

    const getSavedFilesContent = () => {
        const savedOriginal = customFontUploadOriginalName?.trim();
        if (savedOriginal) {
            return {
                tooltip: savedOriginal,
                filename: savedOriginal,
            }
        }

        if (customFontFiles.length > 1) {
            return {
                tooltip: innerFilesTooltip,
                filename: customFontFiles[0].filename,
            }
        }

        return {
            tooltip: innerFilesTooltip,
            filename: '',
        }
    };

    const { tooltip, filename } = getSavedFilesContent();
    return (
        <FontPackageFileActionsList>
            {hasPendingPackage && pendingPackageFileName && (
                <div className="font-package-file-list__file-name">
                    <Tooltip content={pendingPackageFileName}>
                        <FontBody2 color={FONT_COLOR.PRIMARY2}>{pendingPackageFileName}</FontBody2>
                    </Tooltip>
                </div>
            )}
            {!hasPendingPackage && (
                <div className="font-package-file-list__file-name">
                    <Tooltip content={tooltip}>
                        <FontBody2 color={FONT_COLOR.PRIMARY2}>{filename}</FontBody2>
                    </Tooltip>
                    <button className="font-package-file-actions-list__delete-button" onClick={onDeleteCustomFont} disabled={isLoading}>
                        <Icon Component={IconDelete} color={'var(--color-accent-3)'} disabled={isLoading} />
                    </button>
                </div>
            )}
        </FontPackageFileActionsList>
    );
};

export default PortalEdgeFontPackageDisplay;
